// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Ok-z","srOnly":"Pk-z"};